<template>
  <div class="constraint" :class="{['size-' + size]: true}">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
      validator: (value) => {
        return ['xs', 'sm', 'md', 'lg', 'xl'].includes(value)
      }
    }
  }
}
</script>
